import { render } from "./Paper.vue?vue&type=template&id=335090f4&scoped=true"
import script from "./Paper.vue?vue&type=script&lang=js"
export * from "./Paper.vue?vue&type=script&lang=js"

import "./Paper.vue?vue&type=style&index=0&id=335090f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Jude\\Desktop\\projects\\creditclan\\clan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335090f4"]])

export default __exports__